import { ChatProvider } from "../../contexts/chat/provider";
import { LayoutContainer } from "./container";
import { LayoutProvider } from "../../contexts/layout/provider";
import { ModalProvider } from "../../contexts/modal/provider";
import { DemandWalkEditsProvider } from "../../contexts/demand_walk_edits/provider";
import { SupplyWalkEditsProvider } from "../../contexts/supply_walk_edits/provider";

export const AppLayout = (): JSX.Element => {
  return (
    // chat and layout providers are here so that they are inside of routes, as
    // both routing and navigation related logic that requires that
    <LayoutProvider>
      <ModalProvider>
        <DemandWalkEditsProvider>
          <SupplyWalkEditsProvider>
            <ChatProvider>
              <LayoutContainer />
            </ChatProvider>
          </SupplyWalkEditsProvider>
        </DemandWalkEditsProvider>
      </ModalProvider>
    </LayoutProvider>
  );
};
